export const SCORE_WEIGHTS = {
  medianMrr: 0.35,
  averageGrowth30d: 0.2,
  totalMrr: 0.2,
  startupCount: 0.15,
  forSaleRatio: 0.1
} as const;

export function median(values: number[]): number {
  if (!values.length) return 0;
  const sorted = [...values].sort((a, b) => a - b);
  const middle = Math.floor(sorted.length / 2);
  return sorted.length % 2 === 0
    ? (sorted[middle - 1] + sorted[middle]) / 2
    : sorted[middle];
}

export function average(values: number[]): number {
  if (!values.length) return 0;
  return values.reduce((sum, value) => sum + value, 0) / values.length;
}

export function confidenceMultiplier(count: number): number {
  if (count < 5) return 0.65;
  if (count < 10) return 0.8;
  if (count < 15) return 0.9;
  return 1;
}

export function confidenceBand(multiplier: number): "low" | "medium" | "high" {
  if (multiplier >= 1) return "high";
  if (multiplier >= 0.8) return "medium";
  return "low";
}

export function computeOpportunityScore(inputs: {
  medianMrr: number;
  averageGrowth30d: number;
  totalMrr: number;
  startupCount: number;
  forSaleRatio: number;
  startupCountForConfidence: number;
}): number {
  const normalizedMedian = inputs.medianMrr / 100;
  const normalizedGrowth = inputs.averageGrowth30d / 100;
  const normalizedTotalMrr = inputs.totalMrr / 100;
  const normalizedCompetition = inputs.startupCount / 100;
  const normalizedForSale = inputs.forSaleRatio / 100;
  const mult = confidenceMultiplier(inputs.startupCountForConfidence);
  const raw =
    normalizedMedian * SCORE_WEIGHTS.medianMrr +
    normalizedGrowth * SCORE_WEIGHTS.averageGrowth30d +
    normalizedTotalMrr * SCORE_WEIGHTS.totalMrr +
    normalizedCompetition * SCORE_WEIGHTS.startupCount +
    normalizedForSale * SCORE_WEIGHTS.forSaleRatio;
  return Math.round(raw * 100 * mult);
}
